import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import axiosInstance from 'src/utils/axios';

export interface ExportTreeResponse {
  downloadUrl: string;
  fileName: string;
}

export type ClientVisibilityFilter = 'ShowAll' | 'ShowActive' | 'ShowDisabled';

export interface ExportTreeParams {
  companyId: number;
  searchTerm?: string;
  clientFilter?: ClientVisibilityFilter;
  companyFilter?: ClientVisibilityFilter;
}

const useCompanyExportTreeMutation = () => {
  const mutation = useMutation({
    mutationFn: async (params: ExportTreeParams) =>
      axiosInstance.get<ExportTreeResponse>(
        api.getCompanyExportTree(
          params.companyId,
          params.searchTerm,
          params.clientFilter,
          params.companyFilter
        )
      ),
  });

  return { exportExecute: mutation.mutateAsync, exportLoading: mutation.isPending };
};

export default useCompanyExportTreeMutation;
